<template>
  <v-card flat max-height="70vh" class="overflow-auto">

    <v-card-actions class="d-flex pb-0 mb-0">
      <v-tabs v-model="toggleTypeContracts" color="teal darken-3">
        <v-tab key="bid">Оклад</v-tab>
        <v-tab v-show="headDepartment" key="headDepartment">Зав. кафедрой</v-tab>
        <v-tab v-show="dean" key="dean">Декан</v-tab>
      </v-tabs>

      <v-spacer/>
      <v-btn
        small elevation="0"
        class="rounded-xl"
        :disabled="!isReview"
        @click="resetPersonContractsToReview({index: teachersList.indexOf(teacher), id: teacher.teacher_eff_order.id})"
      >
        Вернуть на доработку
      </v-btn>
    </v-card-actions>
    <v-data-table
      :headers="headersContracts"
      :items="pathContracts"
      disable-pagination
      item-key="id"
      hide-default-footer
      fixed-header
      group-by="eff_contract.kind"
      class="rounded-xl"
      calculate-widths
      :loading="loading"
      loading-text="Идёт загрузка..."
      no-data-text="Список пуст"
    >
      <template #top>
        <v-divider/>
      </template>
      <template #item.file="{item, index}">
        <v-chip
          v-if="item.eff_contract.is_auto"
          class="text-truncate"
          style="max-width: 250px"
          @click.stop="$emit('openAutoDetailDialog', item.id)"
          v-text="'Авторасчёт'"
        />

        <v-chip
          v-else
          :href="item.file.link"
          target="_blank"
          class="text-truncate"
          style="max-width: 250px"
          v-text="item.file.filename"
        />

      </template>
      <template #group.header="{items, isOpen, toggle}">
        <th colspan="6">
          <div class="text-body-1 d-flex align-center">
            <v-icon x-small @click="toggle" left>{{ isOpen ? 'fa fa-minus' : 'fa fa-plus' }}</v-icon>
            {{ items[0].eff_contract.kind === "basic" ? "Базовая часть" : "Стимулирующая часть" }}
          </div>
        </th>
      </template>
      <template #item.actions="{ item }">
        <div class="d-flex align-content-space-between">
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                :disabled="!isReview"
                @click="openEditDialog(item)"
              >
                <v-icon>fa fa-edit</v-icon>
              </v-btn>
            </template>
            <span>Редактировать</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                :disabled="!isReview"
                v-bind="attrs"
                v-on="on"
                @click.stop="$emit('confirmed', item.id, 'confirm')"
              >
                <v-icon
                  :color="isContractConfirm(item.status) ?  '#05fa1d' : ''"
                >
                  fa fa-check-circle
                </v-icon>
              </v-btn>
            </template>
            <span>Подтвердить</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                :disabled="!isReview"
                v-bind="attrs"
                v-on="on"
                @click.stop="$emit('remark', item.id, item.status)"
                :color="isContractHasRemark(item.status) ?  'deep-orange' : ''"
              >
                <v-icon>
                  fa-times-circle
                </v-icon>
              </v-btn>
            </template>
            <span>Отклонить</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>

    <the-edit-fact-contract-dialog
      :visible="showEditDialog"
      @close="closeEditDialog"
      @save="saveEditContract"
      :contract="currentContract"
    />
  </v-card>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import TheEditFactContractDialog from "../../../Dialog/TheEditFactContractDialog.vue";
import ApiServices from "../../../services/api.services";
import EffContractServices from "../../../services/EffContract";


export default {
  name: "SubTableEffContract",

  components:{TheEditFactContractDialog},

  props: {
    effContractsByPerson: Array,
    teacher: Object,
    loading: Boolean,

    dialog: {
      type: Boolean,
      default: false,
    }
  },

  watch: {
    dialog: function () {
      if (!this.dialog) {
        this.toggleTypeContracts = 0;
      }
    }
  },

  data() {
    return {
      page: 1,
      itemsPerPage: 999,
      toggleTypeContracts: 0,
      showEditDialog: false,
      currentContract: {},
      headersContracts: [
        {
          text: 'Наименование показателя',
          value: 'eff_contract.indicator_name',
          groupable: false,
          divider: true,
          sortable: false,
        },
        {
          text: 'Ед. измерения', value: 'eff_contract.units_measurement', groupable: false, sortable: false, //width: "5%",
        },
        {
          text: 'План', value: 'eff_contract.plan', groupable: false, sortable: false, //width: '10%',
        },
        {
          text: 'Факт', value: 'fact', groupable: false, sortable: false, //width: '10%',
        },
        {
          text: 'Файл', value: 'file', groupable: false, sortable: false, divider: true, //width: '35%',
        },
        {
          text: 'Действия', value: 'actions', sortable: false, //width: '5%',
        },
      ]
    };
  },

  computed: {

    ...mapState({
      teachersList: state => state.effective_contract.teachersList,
    }),

    ...mapGetters({
      isDean: "effective_contract/isDean",
      isHeadDepartment: "effective_contract/isHeadDepartment",
    }),

    isReview() {
      return this.teacher?.teacher_eff_order?.is_sent_review;
    },

    formattedListPersonEffContractsWithBid() {
      const effContractsWithBid = EffContractServices.findPersonContractsDependentOnBid(this.effContractsByPerson);

      _.forEach(effContractsWithBid, (o) => {
        const index = this.effContractsByPerson.indexOf(o)
        const newPlan = (Number(o.eff_contract.plan) * this.teacher.teacher_eff_order.bid).toString();
        this.effContractsByPerson[index].eff_contract.plan = newPlan;
      });

      return this.effContractsByPerson
    },


    pathContracts() {
      let type = "";

      switch (this.toggleTypeContracts) {
        case 0:
          type = "Оклад";
          break;
        case 1:
          type = "Заведующий кафедрой";
          break;
        case 2:
          type = "Декан";
          break;
        default:
          type = "Оклад"
      }
      return _.filter(this.formattedListPersonEffContractsWithBid, (o) => {
        return o.eff_contract.position === type
      })
    },

    headDepartment() {
      return this.teacher?.teacher_eff_order?.head_department || false;
    },

    dean() {
      return this.teacher?.teacher_eff_order?.dean || false;
    },

  },

  methods: {
    ...mapActions({
      resetPersonContractsToReview: "effective_contract/resetPersonContractsToReview",
    }),

    ...mapMutations({
      setContractsWithTeachersList: "effective_contract/setContractsWithTeachersList",
    }),

    openEditDialog(item) {
      this.currentContract = item;
      this.showEditDialog = true;
    },

    closeEditDialog() {
      this.currentContract = {};
      this.showEditDialog = false;
    },

    async saveEditContract(payload) {
      try {
        const idx = this.teachersList.indexOf(this.teacher);
        const response = await ApiServices.editFactContract(this.currentContract.id, payload);
        await this.setContractsWithTeachersList({index: idx, contracts: response.data.person_eff_contracts});
      } catch (e) {
        console.log(e);
      }
      this.currentContract = {};
      this.showEditDialog = false;
      this.$emit('editFact', this.teacher.teacher_eff_order.id);
    },

    isContractConfirm(status) {
      return status === 'confirm'
    },

    isContractHasRemark(status) {
      return status === 'has_remark'
    },

  },
}
</script>

<style scoped>

.sticky-table-headers__sticky {
  /* Background color */
  background-color: #9ca3af;

  /* Stick to the left */
  left: 0;
  position: sticky;

  /* Displayed on top of other rows when scrolling */
  z-index: 9999;
}

</style>